<template>
<v-container fluid>
  <v-snackbar v-model="snackbar" :color="color" :multi-line="mode === 'multi-line'" :timeout="timeout" :vertical="mode === 'vertical'">
    <slot>{{text}}</slot>
    <v-btn dark flat @click="snackbar = false">
      <v-icon>cancel</v-icon>
    </v-btn>
  </v-snackbar>
  <v-layout row wrap justify-center class="mt-5">
    <v-flex xs12 sm8>
      <div class="headline mb-2">View and Invite Members</div>
      <!-- Invite New Member Card -->
      <member-card key="addButton" @click.native="inviteMember()" add> </member-card>
      <v-data-table color="green" v-model="selected" :headers="headers" :items="items" :pagination.sync="pagination" item-key="displayName" class="elevation-1">
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="changeSort(header.value)">
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <member-card :key="props.item.uid" :photoURL="props.item.photoURL" :displayName="props.item.displayName" />
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
  <!-- Display Invite Code Modal -->
  <v-dialog v-model="displayModal" width="500">

    <v-card>
      <v-card-title class="headline" primary-title>
        <div class="modal-title h5">Activate New Invite Code</div>
      </v-card-title>

      <v-card-text>
        <v-text-field box id="testing-code" color="green lighten-2" v-model="inviteCode" ref="invite"></v-text-field>
        <v-btn @click="copyCode" color="green" dark class="text--white">Create invite Code</v-btn>
        <v-btn @click="copyCode" dark class="green text--white" :href="`mailto:?subject=Your%20Invited%20to%20Join%20a%20Project%20on%20projects.qikbyte.com&body=Hi,%0AHere%20is%20your%20private%20code%20to%20joing%20the%20project%3A%20${this.inviteCode}%0A%0Ahttps://projects.qikbyte.com`">Mail Invite</v-btn>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green lighten-2" flat @click="displayModal = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-container>
</template>

<script>
import MemberCard from "@/components/User/MemberCard";
import Avatar from "@/components/User/Avatar";
import {
  db,
  FirebaseConsts
} from "@/firebaseConfig";
import {
  getGroupData
} from "@/scripts/groupFuncs";
import generateCode from "@/scripts/generateCode";

export default {
  name: "MembersPage",
  components: {
    MemberCard,
    Avatar
  },
  data() {
    return {
      loading: true,
      memberDetails: [],
      displayModal: false,
      inviteCode: "",
      projectGroup: null,
      snackbar: false,
      mode: '',
      timeout: 0,
      text: 'Message Goes Here',
      color: 'red darken-4',
      pagination: {
        sortBy: 'displayName'
      },
      selected: [],
      headers: [{
        text: 'Members',
        align: 'left',
        value: 'displayName',
        sortable: true
      }],
      items: []
    };
  },
  created() {
    // Load initial group data and save it
    getGroupData(this.$route.params.groupID)
      .then(group => {
        this.projectGroup = group;
      })
      .catch(error => {
        console.log(error);
      });

    // Watch for changes on the document, if there is, set group to new info
    db.collection("projects")
      .doc(this.$route.params.groupID)
      .onSnapshot(snapshot => {
        this.projectGroup = snapshot.data();
        this.getMemberInfo();
      });
  },
  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.items.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // TODO: Extract this code to an outside file
    copyCode() {
      // When a user copies the code, the code is saved to firebase
      db.collection("projects")
        .doc(this.$store.getters.activeGroup.groupID)
        .update({
          inviteCodes: FirebaseConsts.firestore.FieldValue.arrayUnion(
            this.inviteCode
          )
        });
      let copyCode = document.querySelector('#testing-code')
      copyCode.select()

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        this.text = 'Invite code was copied and created'
        this.color = 'success'
        this.snackbar = true
      } catch (err) {
        this.text = 'Oops, unable to copy'
        this.snackbar = true
        //alert('Oops, unable to copy');
      }

      /* unselect the range */
      window.getSelection().removeAllRanges()
    },
    inviteMember() {
      this.inviteCode = generateCode();
      this.displayModal = true;
    },
    getMemberInfo() {
      let counter = this.projectGroup.members.length;
      this.memberDetails = [];
      this.items = [];
      this.projectGroup.members.forEach(uid => {
        db.collection("users")
          .where("uid", "==", uid)
          .limit(1)
          .get()
          .then(docSnapshot => {
            if (docSnapshot.size == 1) {
              counter--;
              this.items.push(docSnapshot.docs[0].data());
              if (counter == 0) {
                this.loading = false;
              }
            }
          });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/MembersPage.vue